module.exports = __webpack_public_path__ + "img/full4-min.afb1a636.png";